var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2172,
    height: 280,
    viewBox: "0 0 2172 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_5574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.82 109.954C270.67 109.954 294.481 131.365 294.481 172.553C294.481 232.256 266.326 275.492 192.721 275.492H0L50.4145 204.66H207.243C224.579 204.66 232.068 197.254 232.068 181.2C232.068 170.071 225.572 164.651 212.581 164.651H99.6084C52.5866 164.651 31.5478 138.295 31.5478 98.3486C31.5478 42.3486 60.3236 -0.0599976 132.708 -0.0599976H312.437L261.692 71.5795H118.165C100.829 71.5795 93.3402 77.7855 93.3402 94.2318C93.3402 105.361 99.836 109.871 113.138 109.871L225.82 109.954Z",
    fill: "#F15524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.618 161.028C525.618 240.301 486.21 278.635 405.013 278.635C342.434 278.635 310.824 252.693 310.824 196.776C310.824 117.523 350.13 79.4592 431.43 79.4592C494.009 79.4592 525.618 105.111 525.618 161.028ZM480.583 167.09C480.583 135.956 464.033 129.625 424.727 129.625C366.493 129.625 355.881 141.438 355.881 191.025C355.881 222.055 372.555 228.489 411.529 228.489C469.763 228.489 480.583 216.387 480.583 167.09V167.09Z",
    fill: "#F15524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.021 82.645L686.502 132.708H597.94L594.692 157.781H703.838L670.49 204.761H588.424L579.074 275.449H534.079L559.835 82.645H722.021Z",
    fill: "#F15524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.329 82.645L881.395 132.708H829.863L810.769 275.449H765.982L784.828 132.708H716.829L752.845 82.645H917.329Z",
    fill: "#F15524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.05 1.52588e-05L1079.04 182.812L1200.29 1.52588e-05H1276.08L1110.28 249.114C1099.46 265.167 1084.92 280 1064.77 280C1045.59 280 1034.75 266.409 1027.94 249.114L931.789 1.52588e-05H1010.05Z",
    fill: "#405189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.97 275.449L1260.76 225.8H1296.92C1305.79 225.8 1315.76 225.8 1322.69 226.379C1319.65 219.47 1315.1 207.657 1311.65 198.431L1292.37 147.416L1207.55 275.387H1154.44L1270.5 100.994C1278.07 89.7614 1288.25 79.3764 1302.34 79.3764C1315.76 79.3764 1323.33 88.8925 1328.09 100.994L1395.43 275.449H1226.97Z",
    fill: "#405189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.16 225.8L1539.43 275.449H1411.46L1437.24 82.6243H1481.84L1462.79 225.8H1575.16Z",
    fill: "#405189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.09 225.8L1711.36 275.449H1583.39L1609.17 82.6243H1653.77L1634.72 225.8H1747.09Z",
    fill: "#405189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930.29 225.8L1894.77 275.449H1755.32L1781.1 82.6243H1948.66L1912.96 132.708H1819.2L1816.16 155.857H1930.71L1899.53 199.672H1810.33L1806.85 225.8H1930.29Z",
    fill: "#405189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2171.98 82.645L2068.69 211.774L2060.42 275.47H2015.38L2023.84 211.484L1952.7 82.645H2010.29L2038.01 136.245C2041.69 143.175 2051.21 160.76 2053.38 166.511C2057.29 161.028 2063.13 152.671 2075.68 135.956L2115.75 82.645H2171.98Z",
    fill: "#405189"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_5574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2171.94,
    height: 280,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4ac2f0541fe8422ee86a18af5348476f.svg";
export { ForwardRef as ReactComponent };